/**
 * True when `whenDay` (yyyy-MM-dd) is the calendar day immediately before `today`,
 * using the browser's local calendar (same assumption as the prior `new Date()` "today" check).
 */
export function isWhenDayYesterdayInLocalCalendar(whenDay: string, today: Date): boolean {
  const dayParts = whenDay.split('-');
  if (dayParts.length !== 3) return false;
  const y = Number(dayParts[0]);
  const m = Number(dayParts[1]);
  const d = Number(dayParts[2]);
  if (!y || !m || !d) return false;

  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    y === yesterday.getFullYear() && m === yesterday.getMonth() + 1 && d === yesterday.getDate()
  );
}
